/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const accessibility = () => {

  /**
   * Define things
   */
  const toggleBtn = document.querySelectorAll('.js-wcag-btn');
  const textBtn = document.querySelectorAll('.js-fonts-btn');
  const contrastBtn = document.querySelectorAll('.js-contrast-btn');

  const togglePluginBtn = document.querySelector('.pojo-a11y-toolbar-toggle-link');
  const contrastPluginBtn = document.querySelector('.pojo-a11y-btn-high-contrast');

  let textSize = 0;
  const increaseTextBtn = document.querySelector('.pojo-a11y-btn-resize-plus');
  const decreaseTextBtn = document.querySelector('.pojo-a11y-btn-resize-minus');

  toggleBtn.forEach(btn => {
    btn.addEventListener('click', ()=>{
      togglePluginBtn.click();
    });
  });

  contrastBtn.forEach(btn => {
    btn.addEventListener('click', ()=>{
      contrastPluginBtn.click();
    });
  });

  textBtn.forEach(btn => {
    btn.addEventListener('click', ()=>{
      if (!textSize) {
        increaseTextBtn.click();
        textSize++;
      } else {
        decreaseTextBtn.click();
        textSize--;
      }
    });
  });
};

export default accessibility;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/accessibility.js